<template>
    <sa-page-layout :btnRefreshVisible="false" :toolbarVisible="false">
        <template slot="table-body">
            <button-menu-component :buttonsMenu="buttonsMenu"></button-menu-component>
        </template>
    </sa-page-layout>
</template>

<script>
import ButtonMenuComponent from "../../components/ButtonMenuComponent.vue";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
export default {
    components: { SaPageLayout, ButtonMenuComponent },
    data() {
        return {
            pathResource: null,
            buttonsMenu: [
                { key: 1, text: "Server", icon: "bi bi-hdd-network", click: () => this.onClick("hl7integratorserver") },
                { key: 2, text: "Client", icon: "bi bi-laptop", click: () => this.onClick("hl7integratorclient") },
            ],
        };
    },
    methods: {
        onRefresh() {},
        onClick(page) {
            this.$router.push(page);
        },
    },
};
</script>

<style></style>
